module.exports = __webpack_public_path__ + "static/media/con_relish.19e43ff8.png";